import React from 'react';
import { DocusealForm } from '@docuseal/react';

export default function DocuFormPage() {
  return (
    <div className="app">
      <DocusealForm
        src="https://limewire.com/d/x6ZbL#Jjd24vB5dG"
        email="dhruv.jain9100@gmail.com"
        withSendCopyButton={false}
        withTitle={false}
        onComplete={(data) => console.log(data)}
      />
    </div>
  );
}
